import '../styles/app.scss';
import './_images';
import './components/Scrollbar';
import './ResourcesFeaturedPostVisibility';
import './ctaInject';
import './pages/use-cases';
import './pages/blogs';
import './pages/blog';
import './components/slick.min';
import './components/tabsResize';
import './pages/home-page';
import './pages/product-pages';

import { stickyHeader } from './components/StickyHeader';
import { DisableLink } from './components/DisableLink';
import { PostHashTagHandler } from './components/PostHashTagHandler';
import { CustomerCardToggle } from './components/CustomerCardToggle';
import { homeVideoLightbox } from './components/HomeVideoLightbox';
import { customersPopup } from './components/CustomersPopup';
import { gravityForms } from './components/GravityForms';
import {searchInputPlaceholder} from "./components/SearchInputPlaceholder";
import {sliceSearchTitle} from "./components/SliceSearchTitle";

document.addEventListener(
	'DOMContentLoaded',
	() => {
		stickyHeader();
		DisableLink();
		PostHashTagHandler();
		CustomerCardToggle();
		homeVideoLightbox();
		customersPopup();
		gravityForms();
		searchInputPlaceholder();
		sliceSearchTitle();
	},
	false
);
